var map = {
	"./accompagnements.svg": "91f5",
	"./boissons.svg": "3e32",
	"./desserts.svg": "8da8",
	"./entrees.svg": "8e9a",
	"./fromages.svg": "68d5",
	"./plats.svg": "0546"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "384d";